import { message } from 'antd';
import axios from 'axios';
import config from '../config';

export async function getPrescriptionById(id: string) {
  if (!id || id.trim() == '') return;
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/prescription/getPrescriptionById/${id}`);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}

export async function getPrescriptionBySearch(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/getPrescriptionBySearch`, data);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}

export async function getSubAccount() {
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/prescription/getSubAccount`);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}

export async function getInitialConfig(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/getInitialConfig`, data);
    return Promise.resolve(res.data);
  } catch (err) {}
}

export async function prescriptionFile(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/common/upload/prescriptionFile`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    console.log(error);
  }
}

export async function getProvince(deliveryType: string, language: string) {
  if (!deliveryType || !language) return;
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/common/getProvince/${deliveryType}/${language}`);
    return Promise.resolve(res.data);
  } catch (error) {}
}

export async function getDistrict(deliveryType: string, province_code: string, language: string) {
  if (!deliveryType || !province_code || !language) return;
  try {
    const res = await axios.get(
      `${config.baseUrl}/api/v2/med-link/common/getDistrict/${deliveryType}/${province_code}/${language}`,
    );
    return Promise.resolve(res.data);
  } catch (error) {}
}

export async function getSubDistrict(deliveryType: string, district_code: string, language: string) {
  if (!deliveryType || !district_code || !language) return;
  try {
    const res = await axios.get(
      `${config.baseUrl}/api/v2/med-link/common/getSubDistrict/${deliveryType}/${district_code}/${language}`,
    );
    return Promise.resolve(res.data);
  } catch (error) {}
}

export async function getValidateAddressDeliveryType(deliveryType: string, district_code: string) {
  if (!deliveryType || !district_code) return;
  try {
    const res = await axios.get(
      `${config.baseUrl}/api/v2/med-link/common/getValidateAddressDeliveryType/${deliveryType}/${district_code}`,
    );
    return Promise.resolve(res.data);
  } catch (error) {}
}

export async function getSite(data: any) {
  if (!data) return;
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/common/getSite`, data);
    return Promise.resolve(res.data);
  } catch (error) {}
}

export async function savePrescription(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/savePrescriptionForm`, data);
    return Promise.resolve(res);
  } catch (err) {
    console.log(err);
  }
}

export async function cancelPrescription(id: string, update_by: string) {
  if (!id || !update_by) return;
  try {
    const res = await axios.delete(
      `${config.baseUrl}/api/v2/med-link/prescription/cancelPrescription/${id}/${update_by}`,
    );
    return Promise.resolve(res);
  } catch (error) {
    console.log(error);
  }
}

export async function validateProfile(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/validateProfile`, data);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
    message.error('ไม่สามารถค้นหาข้อมูลได้ โปรดตรวจสอบ !');
  }
}
export async function exportExcel(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/prescription/getPrescriptionExport`, data);
    return Promise.resolve(res);
  } catch (error) {
    console.log(error);
  }
}

export async function getPartnerUser() {
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/prescription/getPartnerUser`);
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
}
